// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Maybe_Trans from "../Control.Monad.Maybe.Trans/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var WeakDynamic = function (x) {
    return x;
};
var weaken = /* #__PURE__ */ (function () {
    var $21 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
    return function ($22) {
        return WeakDynamic(Control_Monad_Maybe_Trans.MaybeT($21($22)));
    };
})();
var unWeakDynamic = function (v) {
    return v;
};
var tagWeakDyn = function (wdyn) {
    return function (event) {
        return Specular_FRP_Base.filterMapEvent(Control_Category.identity(Control_Category.categoryFn))(Specular_FRP_Base.attachDynWith(function (a) {
            return function (_b) {
                return a;
            };
        })(unWeakDynamic(wdyn))(event));
    };
};
var switchWeakDyn = function (v) {
    return Specular_FRP_Base["switch"](Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(Specular_FRP_Base.never))(v));
};
var subscribeWeakDyn_ = function (dictMonadFRP) {
    return function (handler) {
        return function (v) {
            return Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(handler))(v);
        };
    };
};
var monadWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.monadMaybeT(Specular_FRP_Base.monadDynamic);
var mkWeakDynamic = function ($23) {
    return WeakDynamic(Control_Monad_Maybe_Trans.MaybeT($23));
};
var liftEqMaybe = function (eq) {
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Maybe.Just && v1 instanceof Data_Maybe.Just) {
                return eq(v.value0)(v1.value0);
            };
            if (v instanceof Data_Maybe.Nothing && v1 instanceof Data_Maybe.Nothing) {
                return true;
            };
            return false;
        };
    };
};
var uniqWeakDynBy = function (dictMonadFRP) {
    return function (eq) {
        return function (wdyn) {
            return Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(mkWeakDynamic)(Specular_FRP_Base.uniqDynBy(dictMonadFRP)(liftEqMaybe(eq))(unWeakDynamic(wdyn)));
        };
    };
};
var holdWeakDyn = function (dictMonadFRP) {
    return function (change) {
        return Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(function ($24) {
            return WeakDynamic(Control_Monad_Maybe_Trans.MaybeT($24));
        })(Specular_FRP_Base.holdDyn(dictMonadFRP)(Data_Maybe.Nothing.value)(Data_Functor.map(Specular_FRP_Base.functorEvent)(Data_Maybe.Just.create)(change)));
    };
};
var subscribeWeakDyn = function (dictMonadFRP) {
    return function (handler) {
        return function (wdyn) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (v) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(holdWeakDyn(dictMonadFRP)(v.event))(function (result) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(subscribeWeakDyn_(dictMonadFRP)(Control_Bind.composeKleisli(Effect.bindEffect)(handler)(v.fire))(wdyn))(function () {
                        return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(result);
                    });
                });
            });
        };
    };
};
var functorWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.functorMaybeT(Specular_FRP_Base.functorDynamic);
var changedW = /* #__PURE__ */ (function () {
    var $25 = Specular_FRP_Base.filterMapEvent(Control_Category.identity(Control_Category.categoryFn));
    return function ($26) {
        return $25(Specular_FRP_Base.changed(unWeakDynamic($26)));
    };
})();
var bindWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.bindMaybeT(Specular_FRP_Base.monadDynamic);
var attachWeakDynWith = function (f) {
    return function (wdyn) {
        return function (event) {
            return Specular_FRP_Base.filterMapEvent(Control_Category.identity(Control_Category.categoryFn))(Specular_FRP_Base.attachDynWith(function (a) {
                return function (b) {
                    return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(f)(a))(Control_Applicative.pure(Data_Maybe.applicativeMaybe)(b));
                };
            })(unWeakDynamic(wdyn))(event));
        };
    };
};
var applyWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.applyMaybeT(Specular_FRP_Base.monadDynamic);
var applicativeWeakDynamic = /* #__PURE__ */ Control_Monad_Maybe_Trans.applicativeMaybeT(Specular_FRP_Base.monadDynamic);
export {
    unWeakDynamic,
    changedW,
    weaken,
    holdWeakDyn,
    switchWeakDyn,
    subscribeWeakDyn,
    subscribeWeakDyn_,
    attachWeakDynWith,
    tagWeakDyn,
    uniqWeakDynBy,
    functorWeakDynamic,
    applyWeakDynamic,
    applicativeWeakDynamic,
    bindWeakDynamic,
    monadWeakDynamic
};
//# sourceMappingURL=index.js.map
